/* tslint:disable */
/* eslint-disable */
/**
 * gremiumhub
 * A platform for digital applications, approvals and discussions.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: denis.lugowski@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MigrationChangeType } from './MigrationChangeType';
import {
    MigrationChangeTypeFromJSON,
    MigrationChangeTypeFromJSONTyped,
    MigrationChangeTypeToJSON,
    MigrationChangeTypeToJSONTyped,
} from './MigrationChangeType';

/**
 * 
 * @export
 * @interface MigrationChangeDto
 */
export interface MigrationChangeDto {
    /**
     * 
     * @type {MigrationChangeType}
     * @memberof MigrationChangeDto
     */
    type: MigrationChangeType;
    /**
     * Whether this change requires a playbook to be applied. False if auto-migrated or resolved by playbook.
     * @type {boolean}
     * @memberof MigrationChangeDto
     */
    breaking: boolean;
    /**
     * True if this breaking change is handled by a migration playbook.
     * @type {boolean}
     * @memberof MigrationChangeDto
     */
    playbookResolved?: boolean;
    /**
     * The element reference this change concerns (null for section/subsection adds).
     * @type {string}
     * @memberof MigrationChangeDto
     */
    reference?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MigrationChangeDto
     */
    sectionTitle?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MigrationChangeDto
     */
    elementTitle?: string | null;
}



/**
 * Check if a given object implements the MigrationChangeDto interface.
 */
export function instanceOfMigrationChangeDto(value: object): value is MigrationChangeDto {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('breaking' in value) || value['breaking'] === undefined) return false;
    return true;
}

export function MigrationChangeDtoFromJSON(json: any): MigrationChangeDto {
    return MigrationChangeDtoFromJSONTyped(json, false);
}

export function MigrationChangeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): MigrationChangeDto {
    if (json == null) {
        return json;
    }
    return {
        
        'type': MigrationChangeTypeFromJSON(json['type']),
        'breaking': json['breaking'],
        'playbookResolved': json['playbookResolved'] == null ? undefined : json['playbookResolved'],
        'reference': json['reference'] == null ? undefined : json['reference'],
        'sectionTitle': json['sectionTitle'] == null ? undefined : json['sectionTitle'],
        'elementTitle': json['elementTitle'] == null ? undefined : json['elementTitle'],
    };
}

export function MigrationChangeDtoToJSON(json: any): MigrationChangeDto {
    return MigrationChangeDtoToJSONTyped(json, false);
}

export function MigrationChangeDtoToJSONTyped(value?: MigrationChangeDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': MigrationChangeTypeToJSON(value['type']),
        'breaking': value['breaking'],
        'playbookResolved': value['playbookResolved'],
        'reference': value['reference'],
        'sectionTitle': value['sectionTitle'],
        'elementTitle': value['elementTitle'],
    };
}

